import './script-reference-page.css';
import { useEffect, useState } from 'react';
import { Button, Modal, notification } from 'antd';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';

import { addControlStyle } from './script-reference-page-style';
import { useNavigate, useParams } from 'react-router-dom';

import _isUndefined from 'lodash/isUndefined';
import { useDeleteScriptMutation, useLazyGetScriptsQuery, useSaveScriptMutation, useUpdateScriptMutation } from '../../redux/api/scripts';
import { set } from 'lodash';
import { FaTrash } from 'react-icons/fa6';

const ScriptReferencePage = () => {

    const [ id, setId ] = useState<number | undefined>();
    const [ name, setName ] = useState<string>('');
    const [ code, setCode ] = useState<string>('');
    const [ editing, setEditing ] = useState<boolean>(false);
    const [ scripts, setScripts ] = useState<Array<any>>([]);
    const [ tableHeight, setTableHeight ] = useState<number>();

    
    const [getScripts] = useLazyGetScriptsQuery();
    // const [saveScript] = useSaveScriptMutation();
    const [updateScript] = useUpdateScriptMutation();
    const [deleteScript] = useDeleteScriptMutation();
    
    const navigate = useNavigate();

    const updateTableHeight = () => {
        const windowHeight = window.innerHeight; // Full screen height
        const calculatedHeight = windowHeight - 168; // Subtract paddings and headers
        setTableHeight(calculatedHeight);
    };
      
    useEffect(() => {

        fetchScripts();
        updateTableHeight(); // Set height on mount
        window.addEventListener("resize", updateTableHeight); // Adjust height on resize
        return () => window.removeEventListener("resize", updateTableHeight);
    }, []);


    const fetchScripts = async () => {

        try {
          const response = await getScripts(null).unwrap();
          setScripts(response);
        } catch (e) {
        }
    }

    const onEdit = (code: string) => {
        setEditing(true);
        setCode(code);
    }

    /**
     * Adds a user by sending the user data to the server.
     * 
     * @param user the user to add
     */
    const onSave = async (): Promise<void> => {

        try {

            const payload = {
                id,
                name: name,
                script: code
            }

            // const response = id ? await saveScript({id, payload}).unwrap() : createScript(payload).unwrap();
            const response = await updateScript({id, payload}).unwrap();
            setEditing(false);

            // Refresh list
            fetchScripts();

        } catch (e) {
            console.log(e);
            notification.error({
              message: "Saving Script Failed!",
              description: `An error occurred while saving the script`
            });
        }
    }

    const onDelete = async (scriptId: number) => {

        try {

            await deleteScript(scriptId).unwrap();
            notification.success({
                message: "Script Deleted",
                description: `The script was successfully deleted.`
            });

            // Refresh list
            fetchScripts();

            // Clear editor if deleted script is currently loaded
            if (scriptId === id) {
                setId(undefined);
                setCode('');
                setEditing(false);
            }

        } catch (e) {
            console.log(e);
            notification.error({
              message: "Deleting Script Failed!",
              description: `An error occurred while deleting the script`
            });
        }
    }

    const confirmDelete = (scriptId: number) => {
        Modal.confirm({
            title: "Delete Script",
            content: "Are you sure you want to delete this script?",
            okText: "Yes",
            cancelText: "No",
            onOk: () => onDelete(scriptId)
        });
    }

    return <>
        <div style={addControlStyle}>
            <h1>Script References</h1>
            <div className="controls">
            <Button
                type="primary"
                disabled={!editing}
                onClick={onSave}>
                Save Script
            </Button>
            </div>
        </div>
        <div className="reference-content" style={{height: tableHeight}}>
            <div className="reference-list">
                {scripts?.map((script) => <div 
                        key={script.id} 
                        className={`reference-item ${script.id === id ? 'selected' : ''}`}
                        onClick={() => {
                            setId(script.id);
                            setName(script.name);
                            setCode(script.script);
                            setEditing(false);
                        }}>
                        <div className="title">{script.name}</div>
                        <div className="trash">
                            <FaTrash color="lightgray" onClick={() => confirmDelete(script.id)}/>
                        </div>
                    </div>
                )}
            </div>
            <div className="reference-editor">
                <Editor
                    value={code}
                    onValueChange={code => onEdit(code)}
                    highlight={(code) => highlight(code, languages.js!, 'js')}
                    padding={10}
                    style={{
                        minHeight: tableHeight,
                        background: 'white',
                        border: 'none',
                        fontFamily: '"Fira code", "Fira Mono", monospace',
                        fontSize: 14,
                    }}
                />
            </div>
        </div>
    </>
};

export default ScriptReferencePage;

